import {Router} from "@angular/router";
import {Store} from "@ngrx/store";
import {DatasetActions} from "../store/import.actions";

/** Fallback merge target used when the caller doesn't supply one. Merges may target any dataset, not
 *  only "master" — this is just the default when no target was chosen (e.g. the post-import snackbar). */
const DEFAULT_MERGE_TARGET = "master";

/**
 * Navigate to a fund's detail page, first switching the active source dataset to the one the fund
 * was imported into (when known) so the fund loads from the correct dataset, and setting the merge
 * target so the fund's "Merge Targets" panel can search and preview merge candidates.
 *
 * A target must be set: selectFunds/selectAssets filter search results by `target + "/funds"`, so an
 * undefined target matches nothing (WI 1176). Callers pass the target the user chose for the dataset
 * (mirroring the import-overview "Prepare for merge" path); when none is given it defaults to
 * "master". The target stays changeable afterwards via the header's target dropdown.
 *
 * Shared by the import-overview "fund size missing" badge and the post-import warning snackbar.
 */
export function navigateToImportedFund(
    router: Router,
    store: Store,
    fundId: number,
    dataset?: string,
    target: string = DEFAULT_MERGE_TARGET
): void {
    if (dataset) {
        store.dispatch(DatasetActions.setsourceandtarget({source: dataset, target}));
    }
    router.navigate(["/funds", fundId]);
}
